/*============================================================================
 Money Format
 - Shopify.format money is defined in option_selection.js.
 If that file is not included, it is redefined here.
 ==============================================================================*/
if ( ( typeof Shopify ) === 'undefined' ) {
	Shopify = {};
}
if ( ! Shopify.formatMoney ) {
	Shopify.formatMoney = function (cents, format) {
		var value = '',
			placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
			formatString = (format || this.money_format);

		if (typeof cents == 'string') {
			cents = cents.replace('.', '');
		}

		function defaultOption(opt, def) {
			return (typeof opt == 'undefined' ? def : opt);
		}

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal = defaultOption(decimal, '.');

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split('.'),
				dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
				cents = parts[1] ? (decimal + parts[1]) : '';

			return dollars + cents;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	};
}

// Theme functions
window.theme = window.theme || {};

theme.Sections = function Sections() {
	this.constructors = {};
	this.instances = [];

	$( document )
		.on('shopify:section:load', this._onSectionLoad.bind( this ) )
		.on('shopify:section:unload', this._onSectionUnload.bind( this ) )
		.on('shopify:section:select', this._onSelect.bind( this ) )
		.on('shopify:section:deselect', this._onDeselect.bind( this ) )
		.on('shopify:section:reorder', this._onReorder.bind( this ) )
		.on('shopify:block:select', this._onBlockSelect.bind( this ) )
		.on('shopify:block:deselect', this._onBlockDeselect.bind( this ) );
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
	_createInstance: function( container, constructor ) {
		var $container = $( container ),
			id         = $container.attr( 'data-section-id' ),
			type       = $container.attr( 'data-section-type' );

		constructor = constructor || this.constructors[type];

		if ( _.isUndefined( constructor ) ) {
			return;
		}

		var instance = _.assignIn( new constructor( container ), {
			id: id,
			type: type,
			container: container
		});

		this.instances.push( instance );
	},

	// A section has been added or re-rendered.
	_onSectionLoad: function( evt ) {
		var container = $( '[data-section-id]', evt.target )[0];
		if ( container ) {
			this._createInstance(container);
		}
	},

	// A section has been deleted or is being re-rendered.
	_onSectionUnload: function( evt ) {
		this.instances = _.filter( this.instances, function( instance ) {
			var isEventInstance = ( instance.id === evt.detail.sectionId );

			if ( isEventInstance ) {
				if ( _.isFunction(instance.onUnload ) ) {
					instance.onUnload( evt );
				}
			}

			return ! isEventInstance;
		});
	},

	// User has selected the section in the sidebar.
	_onSelect: function( evt ) {
		var instance = _.find( this.instances, function( instance ) {
			return instance.id === evt.detail.sectionId;
		});

		if ( ! _.isUndefined( instance ) && _.isFunction( instance.onSelect ) ) {
			instance.onSelect( evt );
		}
	},

	// User has deselected the section in the sidebar.
	_onDeselect: function( evt ) {
		var instance = _.find( this.instances, function( instance ) {
			return instance.id === evt.detail.sectionId;
		});

		if ( ! _.isUndefined( instance ) && _.isFunction( instance.onDeselect ) ) {
			instance.onDeselect( evt );
		}
	},

	// A section has been reordered.
	_onReorder: function( evt ) {
		var instance = _.find( this.instances, function( instance ) {
			return instance.id === evt.detail.sectionId;
		});

		if ( ! _.isUndefined( instance ) && _.isFunction( instance.onReorder ) ) {
			instance.onReorder( evt );
		}
	},

	// User has selected the block in the sidebar.
	_onBlockSelect: function( evt ) {
		var instance = _.find( this.instances, function( instance ) {
			return instance.id === evt.detail.sectionId;
		});

		if ( ! _.isUndefined( instance ) && _.isFunction( instance.onBlockSelect ) ) {
			instance.onBlockSelect( evt );
		}
	},

	// User has deselected the block in the sidebar.
	_onBlockDeselect: function( evt ) {
		var instance = _.find( this.instances, function( instance ) {
			return instance.id === evt.detail.sectionId;
		});

		if ( ! _.isUndefined( instance ) && _.isFunction( instance.onBlockDeselect ) ) {
			instance.onBlockDeselect( evt );
		}
	},

	register: function ( type, constructor ) {
		this.constructors[type] = constructor;

		$( '[data-section-type=' + type + ']' ).each(function ( index, container ) {
			this._createInstance( container, constructor );
		}.bind( this ) );
	}
});

function colorSwatches() {
	const $nav = document.querySelectorAll('.carousel-nav button')
	$nav.forEach(($item, i) => {
		if (i < $nav.length / 2 ) {
			$item.dataset.imageWhite = $nav[i + $nav.length / 2].querySelector('img').dataset.src
		} else {
			$nav[i].parentElement.removeChild($nav[i])
		}
	});

	const $slider = document.querySelectorAll('.product-image-gallery .glide__slides li')
	$slider.forEach(($item, i) => {
		if (i < $slider.length / 2 ) {
			if ( $($item).attr('data-variant') == 'black' || $($item).attr('data-variant') == 'white' ) {
				$item.dataset.imageWhite = $slider[i + $slider.length / 2].querySelector('img').dataset.src
			}
		} else {
			if ( $($item).attr('data-variant') == 'black' || $($item).attr('data-variant') == 'white' ) {
				$slider[i].parentElement.removeChild($slider[i])
			}
		}
	})

	$( 'body' ).on( 'click', '.swatch-item', function( e ) {
		e.preventDefault();

		var imageNew      = $(this).data('src'),
			imageNewRatio = $(this).data('aspectratio'),
			product       = $(this).parents('.product'),
			productImage  = product.find('.product-image'),
			imageOld      = product.find('.product-image img'),
			variant       = $(this).data('variant'),
			variantId     = $(this).data('variant-id'),
            btnText       = $(this).data('btn-text');
		
		$(this).addClass('swatch-selected').siblings().removeClass('swatch-selected');

		productImage.addClass('loading');
		$('.carousel').addClass('loading');

		imageOld.attr('src', imageNew)
			.attr('data-src', imageNew)
			.attr('data-aspectratio', imageNewRatio)
			.removeClass('lazyautosizes lazyloaded')
			.addClass('lazyload lazypreload');

		if (!imageOld.hasClass('lazyloading')) {
			productImage.removeClass('loading');
		}

		$nav.forEach(($item, i) => {
			const imageVariant = $nav[i].dataset[`image${variant}`]
			if (i < $nav.length / 2 ) {
				$nav[i].querySelector('img').dataset.src = imageVariant
				$nav[i].querySelector('img').dataset.dataSrc = imageVariant
				$nav[i].querySelector('img').dataset.aspectratio = imageNewRatio
				$nav[i].querySelector('img').classList.remove('lazyautosizes','lazyloaded')
				$nav[i].querySelector('img').classList.add('lazyload','lazypreload')
			}
		})
		$slider.forEach(($item, i) => {
			const imageVariant = $slider[i].dataset[`image${variant}`]
			if (i < $slider.length / 2 ) {
				$slider[i].querySelector('img').dataset.src = imageVariant
				$slider[i].querySelector('img').dataset.dataSrc = imageVariant
				$slider[i].querySelector('img').dataset.aspectratio = imageNewRatio
				$slider[i].querySelector('img').classList.remove('lazyautosizes','lazyloaded')
				$slider[i].querySelector('img').classList.add('lazyload','lazypreload')
				setTimeout(function() {
					$('.carousel').removeClass('loading');
				}, 500)
			}
		})

		$('.product-variant-selector').val(variantId).trigger( 'change');
      	setTimeout(function() {
          $('.cta-ajax').html(btnText)
        }, 50)
        if (btnText === 'Sold Out') {
        	$('.cta-ajax').attr('disabled','disabled')
        } else {
        	$('.cta-ajax').removeAttr('disabled')
        }
	});
}

function progressBar() {
	$('.slider').scroll(function() {
		var progress = (70*this.scrollLeft/this.scrollWidth/(1-this.clientWidth/this.scrollWidth) - 70) + '%';

		$('.progress-bar div').css('transform', 'translate3d('+progress+', 0, 0)');
	});
}

function menuHamburger() {
	var mask = '<div class="mask"></div';

	$( 'body' ).on( 'click', '.hamburger', function( e ) {
		$('.menu').addClass('opened');

		$(mask).hide().appendTo('body').fadeIn(500);

		$( '.mask, .menu-close' ).on( 'click', function() {
			$('.menu').removeClass('opened');
			$('.mask').fadeOut(500);

			setTimeout( function() {
				$('.mask').remove();
			}, 500);
		});
	});
}

function tabHandle() {
	$('.menu-top a').click(function(e) {
		e.preventDefault();
		var menu = $(this).attr('data-menu');

		$(this).parents('.menu-top').find('a').removeClass('abba');

		$(this).addClass('abba');
	
		$('.menu-mid-inner').removeClass('opened');
		$('#content-' + menu).addClass('opened');
	})
}

function initProductSlider() {
	if ( $('.slidex').length > 0 ) {
		new Glide('.slidex', {
			type: 'carousel',
			startAt: 1,
			perView: 1,
			focusAt: 'center',
			gap: 0,
			peek: '10vw',
			animationDuration: 750,
			animationTimingFunc: "cubic-bezier(0.25, 0.1, 0.25, 1)",
		}).on('build.before', function() {

		}).mount();

		$(window).on('mousemove', function(e) {
			if ( e.pageX < $(this).width() / 2 ) {
				$('.slidex').addClass('pointer-left').removeClass('pointer-right');
			} else {
				$('.slidex').addClass('pointer-right').removeClass('pointer-left');
			}
		});


		$( 'body' ).on( 'click', '.pointer-right', function(e) {
			if (e.target.tagName === 'DIV') {
				$('.glide__arrow--right').trigger('click')	
			}
		});
		$( 'body' ).on( 'click', '.pointer-left', function(e) {
			if (e.target.tagName === 'DIV') {
				$('.glide__arrow--left').trigger('click')	
			}
		});
	}

	if ( $('.carousel').length > 0 ) {
		new Glide('.carousel', {
			type: 'carousel',
			startAt: 0,
			keyboard: false,
			rewind: false
		}).mount();
	}
}

/*
 * The variant id for a .cta-ajax click.
 *
 * Was `button.prev().val()`. Every buy box in this theme renders
 * <select class="product-variant-selector"> immediately before its button, so
 * the previous sibling was the variant <select> and the shorthand held — until
 * an app injects anything into that gap. On the roundhouse and gambit PDPs the
 * Preorderly embed does exactly that: it puts its ships-from line
 * (.prdly-button_description) and its hidden #preorder-label-value input next
 * to the buy button, so .prev() landed on a <div> or on the properties input
 * instead. jQuery's .val() on those is undefined or the ships-from label, and
 * /cart/add.js answered every pre-order click with
 * "Cart Error(422): Cannot find variant".
 *
 * So look the control up by what it is rather than by where it sits, scoped to
 * the button's own form — the PDP and the sticky header bar each render their
 * own form and their own select, and swiper-swatch keeps every
 * .product-variant-selector on the page in sync. .prev() stays as the last
 * resort so any markup this does not know about behaves as it did before.
 */
function readVariantId( $button ) {
	var $scope = $button.closest('form');
	if ( ! $scope.length ) $scope = $(document);

	// product-add-to-cart renders the select without a name, so match the class
	// first; [name="id"] covers anything that carries the name but not the class.
	var $input = $scope.find('.product-variant-selector').first();
	if ( ! $input.length ) $input = $scope.find('select[name="id"], input[name="id"]:checked, input[name="id"][type="hidden"]').first();
	if ( ! $input.length ) $input = $button.prev();

	return $input.val();
}

function ajaxAddToCart(id, quantity) {
	var mask = '<div class="mask"></div';

	$( 'body' ).on( 'click', '.cta-ajax', function (e) {
		e.preventDefault();
		var _this    = $(this),
			varianId = readVariantId( _this ),
			quantity = 1;

		// Nothing to post. Bail rather than sending `id=undefined` and popping the
		// 422 alert at the shopper.
		if ( ! varianId ) return;

      	if ($('#preorder-label-value').length)
          varianId = varianId + '&' + encodeURIComponent($('#preorder-label-value').attr('name')) + "=" + encodeURIComponent($('#preorder-label-value').attr('value'));
      
		_this.addClass('loading');

		// Render status when add to cart is error
		Shopify.onError = function (XMLHttpRequest, textStatus) {
			var data = eval('(' + XMLHttpRequest.responseText + ')');
			if (!! data.message) {
				alert(data.message + '(' + data.status  + '): ' + data.description);
			}
		};

		//Add item to cart
		Shopify.addItem( varianId, quantity, function ( data ) {
			$('.mini-cart-inner').addClass('opened');

			_this.removeClass( 'loading' );

			Shopify.getCart( function ( all_data ) {
				$( '.cart-icon' ).addClass('cart-icon-has-item')
				$(mask).hide().appendTo('body').fadeIn(500);

				var output = '';

				output += '<div class="df middle-xs mb-x0p5">'
					output += '<div class="width-x10 lg-width-x5 mr-x1 text-center">'
						output += '<img class="lazyload" data-sizes="auto" data-parent-fit="width" data-widths="[400]" data-src="' + data.image + '" width="400" height="400">'
					output += '</div>'
					output += '<div class="mini-cart-item__content start-xs">'
						output += '<h4 class="mini-cart-item__title text-x2 ma-nil">'
							output += '<b>' + data.product_title + '</b>'
						output += '</h4>'
						if ( data.variant_options && data.variant_title ) {
							output += '<div class="mini-cart-item__variant text-x2">';
								for (var i = 0; i < data.variant_options.length; i++) {
									output += data.variant_options[i]
								}
							output += '</div>'
						}
						output += '<span class="text-x3 mb-x0p5 db">Added to your basket!</span>'
						output += '<span class="text-x2">Quantity</span><input class="quantity__input text-x2" type="number" name="updates[]" id="updates_' + data.key + '" value="' + data.quantity + '" min="0" step="1" data-id="' + data.key + '">'
					output += '</div>'
				output += '</div>';
				output += '<a href="/cart/change?line=1&amp;quantity=1" class="update-quantity text-x2 db pa-x0p5 lg-pa-x0p25 bg-b1 text-b4 center-xs border-a2 border-radius-pill">View cart & checkout</a>'

				$('.mini-cart-content').append(output);
			});
		});
	});

	var quantityValue = $('.quantity__input').val();
	$('.mini-cart-content').on('change', function(e) {
		if ( e.target.matches('input')) {
			$('.update-quantity').attr('href', '/cart/change?line=1&amp;quantity=' + e.target.value)
		}
	})

	$( 'body' ).on( 'click', '.mask, .cart-close', function() {
		$('.mini-cart-inner').removeClass('opened');
		$('.mask').fadeOut(500);

		setTimeout( function() {
			$('.mask').remove();
			$('.mini-cart-content').empty();
		}, 500);
	});
}

function headerSticky() {
	$(window).scroll(function() {
		if ( $(window).scrollTop() > 0 ) { 
			$('body').addClass('header-sticky');
		} else { 
			$('body').removeClass('header-sticky');
		}
	});
	var headerHeight = $('.header').outerHeight(),
		topbarHeight = $('.topbar').length ? $('.topbar').outerHeight() : '',
		pdt = headerHeight + topbarHeight;
	
	$('body').css({
		'padding-top': pdt + 'px'
	});
	$('.header').css({
		'top': topbarHeight
	});
}

function headerSearch() {
	$('body').on('click', '.search-icon', function(e) {
		e.preventDefault();
		$('.search').toggleClass('opened');
		$('body').toggleClass('search-opened');
	});
	$('body').on('click', '.search-close', function(e) {
		$('.search').removeClass('opened');
		$('body').removeClass('search-opened');
	});
}

function initExtraPageSlider1() {
    var sliderExtra = document.querySelector('.glide--slider');
    if ( $('.carousel-media-section-glide').length > 0 ) {
    	var glide = new Glide('.carousel-media-section-glide', {
            type: 'slider',
            perView: 1,
            gap: 60,
            animationDuration: 750,
            animationTimingFunc: "ease",
            rewind: false,
            peek: {
                before: window.innerWidth*3/27,
                after: window.innerWidth*3/27
            },
            breakpoints: {
                1023: {
                    gap: 15,
                    peek: {
                        before: window.innerWidth*2/27,
                        after: window.innerWidth*2/27
                    }
                }
            }
		})
        .on('run', function(e) {
            var index = glide.index;
            var dir = e.direction;
            var children = $('.carousel-media-section-glide .glide__slides').children();
            if (index == 0) {
                $('.carousel-media-section-glide').addClass('glide__first-slide');
            } else if (index == children.length - 1) {
                $('.carousel-media-section-glide').addClass('glide__last-slide');
            } else {
                $('.carousel-media-section-glide').removeClass('glide__first-slide glide__last-slide');
            }
        })
		.on('build.after', function() {
            $('.carousel-media-section-glide').addClass('glide__first-slide');
		}).mount();
	}
}

function initExtraPageSlider() {
	var sliderExtra = document.querySelector('.glide--slider');
	if ( $('.overlay-e-carousel-glide').length > 0 ) {
		var glide = new Glide('.overlay-e-carousel-glide', {
			type: 'slider',
  			perView: 1,	
			gap: 45,
		 	animationDuration: 750,
		 	animationTimingFunc: "ease",
		 	rewind: false,
			peek: {
			    before: window.innerWidth*3/27,
			    after: window.innerWidth*6/27
		  	},
		  	breakpoints: {
		  		1023: {
		  			gap: 15,
		  			peek: {
					    before: window.innerWidth*2/27,
					    after: window.innerWidth*2/27
				  	}
		  		}
		  	}
		})
		.on('build.after', function() {
			$('.overlay-e-carousel-glide').addClass('glide__first-slide');
			$('.glide_count').html('1 / ' + $('.glide_count').attr('data-glide-count'));
		})
		.on('run.after', function() {
			$('.overlay-e-carousel-glide .glide__slides')
				.children()
				.removeClass('glide__slide--moving-in')
				.removeClass('glide__slide--moving-out');
		})
		.on('run.before', startHandler)
		.on('run', function(e) {
			var index = glide.index;
			var dir = e.direction;
			var children = $('.overlay-e-carousel-glide .glide__slides').children();
			if (index == 0) {
				$('.overlay-e-carousel-glide').addClass('glide__first-slide');
			} else if (index == children.length - 1) {
				$('.overlay-e-carousel-glide').addClass('glide__last-slide');
			} else {
				$('.overlay-e-carousel-glide').removeClass('glide__first-slide glide__last-slide');
			}
			$('.glide_count').html((index + 1) + ' / ' + $('.glide_count').attr('data-glide-count'));
		})
		.mount();

		function startHandler(e) {
			var index = glide.index;
			var dir = e.direction == '|' ? e.steps : e.direction;
			var children = $('.overlay-e-carousel-glide .glide__slides').children();
			if (index == 0 && dir == '<') return
			if (index == children.length - 1 && dir == '>') return
			var nextIndex = dir == '>' ? (index >= children.length - 1 ? 0 : index + 1) : dir == '<' ? (index == 0 ? children.length - 1 : index - 1) : index;

			var movingOut = children.eq(index);
			var movingIn = children.eq(nextIndex);

			if (dir == '>') {
				movingOut.removeClass('glide__slide--left-top').addClass('glide__slide--right-top');
			} else {
				movingOut.removeClass('glide__slide--right-top').addClass('glide__slide--left-top');
			}

			movingIn.addClass('glide__slide--moving-in');
			movingOut.addClass('glide__slide--moving-out');
		}
	}
}

$( document ).ready( function () {
	colorSwatches();
	progressBar();
	menuHamburger();
	tabHandle();
	initProductSlider();
	ajaxAddToCart();
	headerSticky();
	headerSearch();
	initExtraPageSlider();
    initExtraPageSlider1();
});

document.addEventListener('DOMContentLoaded', () => {
  const productJson = [...document.querySelectorAll('[id^=ProductJson-')];
  if (productJson.length > 0) {
    productJson.forEach((product) => { 
      const sectionId = product.id.replace("ProductJson-", "shopify-section-");
      const productVariants = JSON.parse(product.innerHTML);
      const unavailableVariants = [];
      productVariants.variants.forEach((variant) => {
        if (variant.available === false) {
          unavailableVariants.push(variant);
        }
      });
      const variantOptions = [...document.querySelectorAll('#' + sectionId + ' .single-option-selector option')]
      const observer = new MutationObserver((mutation) => {
        unavailableVariants.forEach((item) => {
          variantOptions.forEach((option) => {
            if (option.value === item.title) option.setAttribute('disabled', '');
          });
        });
        observer.disconnect();
      });
      if (unavailableVariants.length > 0 && productVariants.options.length === 1) {
        const addToCartForm = document.querySelector('form[ action="/cart/add"]');
        if (window.MutationObserver && addToCartForm.length) {
          if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
            observer.disconnect();
          }
          const config = { childList: true, subtree: true };
          observer.observe(addToCartForm, config);
        }
      }
    });
  }
});